module.exports = __webpack_public_path__ + "img/upBack.a848b9a4.png";